import request from '@/utils/request'

export function getBanners() {
    return request({
        url: 'GetBanners',
        method: 'post'
    })
}
export function getMenulist() {
    return request({
        url: 'GetChildMenuByParentid?menuid=0',
        method: 'post'
    })
}
//分页
export function GetArticleByMenuId(menuid) {
    return request({
        url: 'GetArticleByMenuId',
        method: 'post',
        params: {
            menuid
        }
    })
}
//不分页
export function GetArticleListBySId(sujectid) {
    return request({
        url: 'GetArticleList',
        method: 'post',
        params: {
            sujectid
        }
    })
}
export function GetArticleById(id) {
    return request({
        url: 'GetArticleById',
        method: 'post',
        params: {
            id
        }
    })
}
export function GetMenuAndArticleByPId(id) {
    return request({
        url: 'GetMenuAndArticleByPId',
        method: 'post',
        params: {
            id
        }
    })
}
export function PFBJMenuAndArticleByPId(id) {
    return request({
        url: 'PFBJMenuAndArticleByPId',
        method: 'post',
        params: {
            id
        }
    })
}
export function GetArticleListByMenuType(type) {
    return request({
        url: 'GetArticleListByMenuType',
        method: 'post',
        params: {
            type
        }
    })
}
export function PFBJGetArticleListByMenuType(type) {
    return request({
        url: 'PFBJGetArticleListByMenuType',
        method: 'post',
        params: {
            type
        }
    })
}
export function GetAllMenuAndArticleByPId(id){
    return request({
        url: 'GetAllMenuAndArticleByPId',
        method: 'post',
        params: {
            id
        }
    })
}

export function PFBJLetAgenMapById(id) {
    return request({
        url: 'PFBJLetAgenMapById',
        method: 'post',
        params: {
            id
        }
    })
}
export function EditCollect(data) {
    return request({
        url: 'EditCollect',
        method: 'post',
        data
    });
}
export function GetCollectList(data) {
    return request({
        url: 'GetCollectList',
        method: 'post',
        data
    })
}
export function GetCollctAgendaList(data) {
    return request({
        url: 'GetCollctAgendaList',
        method: 'post',
        data
    })
}
